import {
  ExternalIntegration,
  ExternalIntegrationEnum,
  FacebookProfile,
  InstagramProfile,
  LinkedInProfile,
  TikTokProfile,
  WordPressProfile,
  XProfile,
  YouTubeProfile,
} from 'api/clients/ExternalIntegrationsClient'
import { absurd } from 'types'

export const extractProfileInfo = (externalIntegration: ExternalIntegration) => {
  let profile
  const { provider } = externalIntegration
  switch (provider) {
    case ExternalIntegrationEnum.Facebook:
      profile = externalIntegration.additional_data || ({} as FacebookProfile)
      return {
        avatar: externalIntegration.picture || profile.picture?.data?.url,
        name: externalIntegration.name || profile.name,
        showAvatar: true,
        username: '',
        email: '',
      }
    case ExternalIntegrationEnum.Instagram:
      profile = externalIntegration.additional_data || ({} as InstagramProfile)
      return {
        avatar: externalIntegration.picture || profile.profile_picture_url,
        name: externalIntegration.additional_data?.username || externalIntegration.name,
        showAvatar: true,
        username: profile.username,
        email: '',
      }
    case ExternalIntegrationEnum.LinkedIn:
      profile = externalIntegration.additional_data || ({} as LinkedInProfile)
      return {
        avatar: externalIntegration.picture || profile.picture,
        name: externalIntegration.name || profile.name,
        showAvatar: true,
        email: profile.email,
        username: '',
      }
    case ExternalIntegrationEnum.X:
      profile = externalIntegration.additional_data || ({} as XProfile)
      return {
        avatar: externalIntegration.picture || profile.profile_image_url,
        name: externalIntegration.name || profile.name,
        showAvatar: true,
        username: profile.username,
        email: '',
      }
    case ExternalIntegrationEnum.WordPress:
      profile = externalIntegration.additional_data || ({} as WordPressProfile)
      return {
        avatar: null,
        name: externalIntegration.name || profile.url,
        showAvatar: false,
        username: '',
        email: '',
      }
    case ExternalIntegrationEnum.TikTok:
      profile = externalIntegration.additional_data || ({} as TikTokProfile)
      return {
        avatar: externalIntegration.picture,
        name: externalIntegration.name || profile.username,
        showAvatar: true,
        username: profile.username,
        email: '',
      }
    case ExternalIntegrationEnum.YouTube:
      profile = externalIntegration.additional_data || ({} as YouTubeProfile)
      return {
        avatar: externalIntegration.picture,
        name: externalIntegration.name || profile.username,
        showAvatar: true,
        username: profile.username,
        email: '',
      }
    case ExternalIntegrationEnum.Google:
      const { default_uri } = externalIntegration.additional_data || {}
      return {
        avatar: externalIntegration.picture,
        name: default_uri || externalIntegration.name,
        showAvatar: true,
        username: '',
        email: '',
      }
    case ExternalIntegrationEnum.GoogleBusinessProfile:
      return {
        avatar: externalIntegration.picture,
        name: externalIntegration.name,
        showAvatar: false,
        username: '',
        email: '',
      }
    case ExternalIntegrationEnum.GoogleDrive:
      return {
        avatar: externalIntegration.picture,
        name: externalIntegration.name,
        showAvatar: false,
        username: '',
        email: '',
      }
    case ExternalIntegrationEnum.Mailchimp:
      return {
        avatar: externalIntegration.additional_data?.avatar_url || '',
        name: externalIntegration.name,
        showAvatar: true,
        username: '',
        email: '',
      }
    case ExternalIntegrationEnum.MetaAds:
      return {
        avatar: '',
        name: externalIntegration.name,
        showAvatar: false,
        username: '',
        email: '',
      }
    case ExternalIntegrationEnum.GoogleAds:
      return {
        avatar: '',
        name: externalIntegration.name,
        showAvatar: false,
        username: '',
        email: '',
      }
    case ExternalIntegrationEnum.GoHighLevel:
      return {
        avatar: '',
        name: externalIntegration.name,
        showAvatar: false,
        username: '',
        email: '',
      }
    case ExternalIntegrationEnum.Wix:
      return {
        avatar: '',
        name: externalIntegration.name,
        showAvatar: false,
        username: '',
        email: '',
      }
    case ExternalIntegrationEnum.Shopify:
      return {
        avatar: '',
        name: externalIntegration.name,
        showAvatar: false,
        username: '',
        email: '',
      }
    case ExternalIntegrationEnum.Zapier:
      return {
        avatar: '',
        name: externalIntegration.name,
        showAvatar: false,
        username: '',
        email: '',
      }
    default:
      absurd(provider)
      return {
        avatar: '',
        name: '',
        showAvatar: false,
        username: '',
        email: '',
      }
  }
}

export const formatHandle = (username?: string | null, email?: string | null) => {
  if (username) return `@${username.replace(/^@/, '')}`
  return email || null
}
